import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { RootState } from 'store/ducks';
import { useDispatch, useSelector } from 'react-redux';

import Table from '../../index';
import { CteStockTableSearch } from './CteStockTableSearch';

import CteServices from 'services/cte.service';
import { CTeStockTableProps, TableStockCTeFilterState } from './interface';

import { IBatchRequestResponse } from 'models/Batch';
import { CTeStockState } from 'models/CTEs';
import { checkLabelExpirationDay } from './utils';
import { useLoadCte } from 'hooks/useLoadCte';

export const CTEStockTable: React.FC<CTeStockTableProps> = (props) => {

  const {
    trackingKey,
    tableSearchClassName,
    currentTabId,
    DropdownTemplate
  } = props;

  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const customer = useSelector((state: RootState) => state.customer);

  const { customerIds } = useLoadCte();

  const cteService = new CteServices();

  const [tableFilter, setTableFilter] = useState<TableStockCTeFilterState>({
    expirationDate: null,
    searchProduct: ""
  });

  const [dataCte, setDataCte] = useState<IBatchRequestResponse<CTeStockState>>();

  const [tableOrderBy, setTableOrderBy] = useState('desc');
  const [currentPage, setCurrentPage] = useState(0);

  const pageTotal = props.pageSize || 10;

  useEffect(() => {
    if (!currentTabId) return;
    dispatch({
      type: 'SET_CURRENT_TAB',
      data: currentTabId
    });
  }, []);

  useEffect(() => {
    getStockCte();
  }, [currentPage, tableFilter, tableOrderBy, customer, user?.selectedCustomerId]);

  const getStockCte = useCallback(() => {
    setDataCte(undefined);

    cteService
      .getStockCTe(currentPage, pageTotal, tableOrderBy, tableFilter, customerIds)
      .then((result: IBatchRequestResponse<CTeStockState>) => {

        if (result) {
          const { error, data, totalPages, pageSize, total } = result;

          data?.forEach((item: CTeStockState) => {
            item.daysToExpireLabel = checkLabelExpirationDay(item);
          });

          setDataCte({ error, data, totalPages, pageSize, total });
        }
      });
  }, [currentPage, tableFilter, tableOrderBy, customer, user?.selectedCustomerId]);

  const CTETableRender = useMemo(() => (
    <Table
      trackingKey={trackingKey}
      className="mt-3"
      error={dataCte?.error || false}
      onReload={getStockCte}
      setTableOrder={setTableOrderBy}
      tableOrder={tableOrderBy}
      DropdownTemplate={DropdownTemplate || undefined}
      currentPage={currentPage}
      data={dataCte?.data}
      pageSize={pageTotal}
      onPageChange={setCurrentPage}
      totalPages={dataCte?.totalPages}
      model={props.model || []}
      totalOrder={dataCte?.total}
    />
  ), [dataCte, user?.selectedCustomerId, customer, tableOrderBy]);

  return (
    <>
      <CteStockTableSearch
        className={tableSearchClassName}
        setTableFilter={setTableFilter}
        setCurrentPage={setCurrentPage}
        integrationUpdatedDate={(dataCte?.data && dataCte.data[0]?.integrationUpdatedDate) || ""}
      />

      {CTETableRender}
    </>
  );
};
